import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { getSession, login as loginFn, logout as logoutFn, onAuthStateChange, setSession as saveSession } from './auth.js'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [ready, setReady] = useState(false)
  const [session, setSession] = useState(null)

  useEffect(() => {
    const savedSession = getSession()
    if (savedSession) {
      setSession(savedSession)
    }
    setReady(true)
    
    const unsubscribe = onAuthStateChange((newSession) => {
      if (newSession) {
        setSession(newSession)
      } else {
        setSession(null)
      }
    })
    
    return () => {
      unsubscribe()
    }
  }, [])

  const value = useMemo(() => {
    return {
      ready,
      session,
      async login(payload) {
        try {
          const s = await loginFn(payload)
          setSession(s)
          if (typeof window !== 'undefined') window.currentSession = s
          return s
        } catch (err) {
          throw new Error(err?.message || err?.toString() || 'Erro ao fazer login. Verifique suas credenciais.')
        }
      },
      async logout() {
        await logoutFn()
        setSession(null)
      },
      enterEmpresa(empresa) {
        const original = session
        const newSession = {
          ...session,
          empresaId: empresa.id,
          empresaNome: empresa.nome,
          _superAdminOriginal: original,
          _impersonating: true
        }
        saveSession(newSession)
        setSession(newSession)
        if (typeof window !== 'undefined') window.currentSession = newSession
      },
      exitEmpresa() {
        const original = session?._superAdminOriginal
        if (!original) return
        saveSession(original)
        setSession(original)
        if (typeof window !== 'undefined') window.currentSession = original
      }
    }
  }, [ready, session])

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth deve ser usado dentro de AuthProvider')
  return ctx
}
